import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  cancelAccountDeletion,
  requestAccountDeletion,
  type AccountDeletionResponse,
} from "../api/account.api";
import { assertStepUpProofWanted, type StepUpProof } from "../api/stepup.api";
import { accountKeys } from "./useAccount";
import { ApiError } from "@/lib/api/client";

export function useRequestAccountDeletion() {
  return useMutation<AccountDeletionResponse, ApiError, { password: string; stepUp?: StepUpProof }>(
    {
      mutationFn: ({ password, stepUp }) => {
        assertStepUpProofWanted(stepUp);
        return requestAccountDeletion(password, stepUp);
      },
      networkMode: "always",
    },
  );
}

export function useCancelAccountDeletion() {
  const queryClient = useQueryClient();

  return useMutation<void, ApiError, void>({
    mutationFn: cancelAccountDeletion,
    onSuccess: async () => {
      await queryClient.invalidateQueries();
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: accountKeys.me() });
    },
  });
}
